<template lang="pug">
.fam-zoom-card(:class="transitioning? 'transitioning': ''")
  slot
  
</template>
<script>
export default {
  name: 'FamZoomCard',
  props: {
    idx: {},
    total: {},
    progress: {},
    transitioning: {},
  },
  data() {
    return {}
  },
  watch: {
    progress(val) {
      this.zooming(val, this.idx, this.total)
    },
  },
  computed: {},
  methods: {
    zooming(progress, idx, total) {
      let ofs = progress * (total - 1)
      let factor = -Math.cos(Math.PI * ofs + idx * Math.PI)
      let scale = 0.085 * factor + 0.915
      let opacity = 0.2 * factor + 0.8
      this.$el.style.transform = `scale(${scale})`
      this.$el.style.opacity = opacity
    },
  },
  mounted() {
    this.zooming(this.progress, this.idx, this.total)
  },
}
</script>

<style scoped lang="sass">
@import "../../styles/common"
.fam-zoom-card
  width: 100%
  height: 100%
  //background: rebeccapurple
  //transition: all 0.3s
  &.transitioning
    transition: all 0.3s ease
</style>
